module.exports = __webpack_public_path__ + "img/tool-02.e18b6a0f.svg";